import initialState from './initialState';
import * as actionTypes from '../constants/actionTypes';

export default function subscriptionReducer(state = initialState.subscription, action) {
  switch(action.type) {
    case actionTypes.SUBSCRIPTION_MODAL_SHOW:
      return {...state, isModalOpen: true, isShown: true};

    case actionTypes.SUBSCRIPTION_MODAL_HIDE:
      return {...state, isModalOpen: false};

    case actionTypes.SUBSCRIPTION_CREATE__SUCCESS:
      return {...state, isSubscribed: true};

    case actionTypes.SUBSCRIPTION_CREATE__FAILURE:
      return {...state, isSubscribed: false};

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/subscriptionReducer.js